// jquery-ui modules bundle as browser-global UMD (no CJS branch), so the
// `./version` dependency that creates `$.ui` never loads implicitly — import
// it explicitly before any other jquery-ui module or `$.ui.*` assignments throw.
import "jquery-ui/ui/version";
import "jquery-ui/ui/widget";
import "jquery-ui/ui/position";
import "jquery-ui/ui/unique-id";
import "jquery-ui/ui/keycode";
import "jquery-ui/ui/widgets/menu";
import "jquery-ui/ui/widgets/button";
import "jquery-ui/ui/widgets/datepicker";
import "moment"; // VITE_MIGRATION: use npm moment instead of vendored UMD copy (crashes in ESM strict mode)
import "#vendor/jquery.daterangepicker.js";

// Dependencies as stated on https://github.com/tamble/jquery-ui-daterangepicker

jQuery(function () {
  jQuery("[data-behaviour~=date-range-picker]").each(function () {
    jQuery(this).daterangepicker({
      datepickerOptions: {
        numberOfMonths: 2,
        maxDate: jQuery(this).data("max-lookahead-days"),
      },
    });
  });
});
